import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xl text-left font-mono font-bold text-blue-900" }
const _hoisted_2 = { class: "text-blue-900 font-mono font-bold" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_4 = { class: "text-blue-900 font-mono font-bold" }
const _hoisted_5 = { class: "text-blue-900 font-mono font-bold" }
const _hoisted_6 = { class: "text-blue-900 font-mono font-bold" }
const _hoisted_7 = { class: "text-blue-900 font-mono font-bold" }

import { Modal as AntModal, Button } from "ant-design-vue";
import * as yup from "yup";
import { ref } from "vue";

import { IInformationProfile } from "@/models/IInformationProfile";
import i18n from "@/services/i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'modalUpdateInformationAccount',
  props: {
    user: {},
    isVisible: { type: Boolean }
  },
  emits: ["update:isVisible"],
  setup(__props: any, { emit: __emit }) {



// Validate form information profile
const formModelInformationProfile = ref<IInformationProfile>({
  email: "",
  username: "",
  bio: "",
  fullName: "",
  address: "",
  phone: "",
  dob: "",
  nickname: "",
  hobbies: "",
  createdTime: "",
  updatedTime: "",
  avatar: "",
  linkGithub: "",
  linkFacebook: "",
  linkInstagram: "",
  linkTwitter: "",
});

const errors = ref<Record<string, string>>({});
const schema = yup.object().shape({
  fullName: yup.string().required(),
  username: yup.string().required(),
});

const rules = ref({
  fullName: [
    {
      required: true,
      message: i18n.global.t(
        "NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.VALIDATE.FULL_NAME"
      ),
    },
  ],
  username: [
    {
      required: true,
      message: i18n.global.t(
        "NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.VALIDATE.USERNAME"
      ),
    },
  ],
  dob: [
    {
      required: false,
    },
  ],
});

const handleUpdateInformationProfile = async () => {
  try {
    await schema.validate(formModelInformationProfile.value, {
      abortEarly: false,
    });
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      const errorMessages: Record<string, string> = {};
      err.inner.forEach((error) => {
        if (error.path) {
          const rule = rules.value[error.path as keyof typeof rules.value][0];
          if (rule && "message" in rule) {
            errorMessages[error.path as keyof typeof rules.value] =
              rule.message;
          }
        }
      });
      errors.value = errorMessages;
    }
  }
};

// Action
const emit = __emit;
const closeModal = () => {
  emit("update:isVisible", false);
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_unref(AntModal), {
    visible: _ctx.isVisible,
    onCancel: closeModal
  }, {
    title: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(i18n).global.t(
            "NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.UPDATE_INFORMATION"
          )), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        onSubmit: handleUpdateInformationProfile,
        model: formModelInformationProfile.value,
        rules: rules.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "fullName",
            rules: rules.value.fullName,
            "validate-status": errors.value.fullName ? 'error' : '',
            help: errors.value.fullName
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_2, [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t("NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.NAME")) + " ", 1),
                (rules.value.fullName[0].required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_a_input, {
                placeholder: "...",
                class: "border-blue-900 focus:border-blue-700 hover:border-blue-700",
                modelValue: formModelInformationProfile.value.fullName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModelInformationProfile.value.fullName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["rules", "validate-status", "help"]),
          _createVNode(_component_a_form_item, { name: "nickname" }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(i18n).global.t("NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.NICKNAME")), 1),
              _createVNode(_component_a_input, {
                placeholder: "...",
                class: "border-blue-900 focus:border-blue-700 hover:border-blue-700",
                modelValue: formModelInformationProfile.value.nickname,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModelInformationProfile.value.nickname) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "hobbies" }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(i18n).global.t("NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.HOBBIES")), 1),
              _createVNode(_component_a_input, {
                placeholder: "...",
                class: "border-blue-900 focus:border-blue-700 hover:border-blue-700",
                modelValue: formModelInformationProfile.value.hobbies,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModelInformationProfile.value.hobbies) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "address" }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(i18n).global.t("NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.ADDRESS")), 1),
              _createVNode(_component_a_textarea, {
                placeholder: "...",
                rows: "2",
                class: "border-blue-900 focus:border-blue-700 hover:border-blue-700",
                modelValue: formModelInformationProfile.value.address,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModelInformationProfile.value.address) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "dob",
            rules: rules.value.dob,
            "validate-status": errors.value.dob ? 'error' : '',
            help: errors.value.dob
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(i18n).global.t("NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.DOB")), 1),
              _createVNode(_component_a_date_picker, {
                format: "DD/MM/YYYY",
                "default-value": "2000-01-01",
                placeholder: "...",
                class: "border-blue-900 focus:border-blue-700 hover:border-blue-700 w-full hover:cursor-pointer",
                modelValue: formModelInformationProfile.value.dob,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formModelInformationProfile.value.dob) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["rules", "validate-status", "help"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        onClick: closeModal,
        class: "text-blue-900 hover:text-blue-700 border-blue-900 hover:border-blue-700"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t("NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.CANCEL")), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        type: "primary",
        class: "text-white bg-blue-900 hover:bg-blue-700 focus:bg-blue-900",
        onClick: handleUpdateInformationProfile
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t(
            "NAVIGATION_MENU.ACCOUNT_SECTION.PROFILE.UPDATE_INFORMATION"
          )), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})